import { colors, IMForm, typography } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const IMFormStyled = styled(IMForm)`
  margin: 0 auto;
  padding: 0 9rem;
  max-width: unset;
  position: relative;
`;

export const FormDivider = styled.p`
  ${typography.regular[12]}
  color: ${colors.neutral[600]};
  text-transform: uppercase;
  padding-bottom: 1rem;
  margin: 2rem 0 0;
  border-bottom: 1px solid ${colors.neutral[300]};
  width: 100%;
`;
